import { ConfigProvider, Modal } from 'antd'
import type { ReactNode } from 'react'
import './popup-modal.css'

export interface PopupModalProps {
  children?: ReactNode
  onCancel?: () => void
  isModalOpen?: boolean
  width?: string | number
  height?: string | number
  title?: ReactNode
  [key: string]: any
}

export function PopupModal({
  children,
  onCancel,
  isModalOpen,
  width,
  height,
  ...props
}: PopupModalProps) {
  return (
    <ConfigProvider theme={{ token: { borderRadius: 0, borderRadiusLG: 0 } }}>
      <Modal
        className='glasspro-modal'
        width={width ?? 'max-content'}
        open={isModalOpen}
        onCancel={onCancel}
        destroyOnHidden
        zIndex={1100}
        footer={null}
        {...props}
      >
        {children}
      </Modal>
    </ConfigProvider>
  )
}
